import { findSpellMaterialStack, materialRequirement } from '../actions/spell-components.js';
import { type JanusCtx, type Row, insertRoll, int, upper } from './context.js';

/** Consumed components are paid once the spell survives bending, miscast and counterspell, before its effects. */
export function consumeSpellMaterials(ctx: JanusCtx, ability: Row, caster: Row): void {
  if (!ctx.read.has(ability, 'spell_component_material_consumed')) return;
  for (const entry of ctx.read.entries(ability, 'spell_material_item_id')) {
    const [uuid, template, qty] = materialRequirement(entry);
    if (!uuid) continue;
    const held = findSpellMaterialStack(caster.inventory, uuid, template, qty);
    if (!held) continue; // The component gate owns missing-material refusals; legacy settlement skipped a missing stack.
    const id = upper(ctx.read.inventoryField?.(held, 'inventory_id'));
    const before = {
      possess_id: String(ctx.read.inventoryField?.(held, 'possess_id') ?? ''),
      item_qty: int(ctx.read.inventoryField?.(held, 'item_qty') ?? 1),
      inventory_deleted: int(ctx.read.inventoryField?.(held, 'inventory_deleted') ?? 0),
    };
    const remaining = before.item_qty - qty;
    (ctx.weaponInventoryChanges ??= []).push({ inventory_id: id, before,
      after: { item_qty: remaining, inventory_deleted: remaining === 0 ? 1 : 0 }, log_type: 'inventory_deleted' });
    insertRoll(ctx, { roll_type_1: 'inventory_deleted', roll_item_id: id, by: caster,
      roll_result: qty, logMessage: false });
  }
}
